import "./PPZoneOrganizationService.module.css";
import NewsHero from "@/pages/PPZone/sections/NewsHero";
import ZonaPPHero from "./sections/ZonaPPHero";
import OrganizationalServices from "./sections/OrganizationalServices";
import ServiceBenefitsGrid from "./sections/ServiceBenefitsGrid";
import Footer from "@/reusable_sections/Footer";
export default function PPZoneOrganizationServicePage() {
  return <div>
      <NewsHero activeMenu="/zona-pp/layanan-organisasi" />
      <ZonaPPHero />
      <OrganizationalServices />
      <ServiceBenefitsGrid />
      <Footer />
    </div>;
}